import {useSelector,useDispatch} from 'react-redux'
import {fetchByTag,selectAllRecipes} from './recipesSlice'

export const useRecipes = ()=>{
	const dispatch = useDispatch()
	const status = useSelector(state=>state.recipes.status)
	if ( status === 'init' ) {
		console.log('todo load recipes')
		dispatch(
			fetchByTag({tags:[],loadInBackground:false})
		)
	}
	const recipes = useSelector(selectAllRecipes)
	return {status,recipes}
}